import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AddBOUserRPC } from "./addBoUserRPC";

export class AddBOUserRPCClientImpl extends AddBOUserRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AddBOUserRPC.Request): Promise<LeoRPCResult<AddBOUserRPC.Response, AddBOUserRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/AddBOUser",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AddBOUserRPC.ResponseDTO,
      AddBOUserRPC.Errors.ErrorsDTO,
      AddBOUserRPC.Response,
      AddBOUserRPC.Errors.Errors
    >(
      response,
      "bo-user-management/AddBOUser",
      AddBOUserRPC.Response.fromDTO,
      AddBOUserRPC.Errors.fromDTO
    );
  }
}
